<template>
  <v-container fluid>
    <v-layout>
        <invite-response-form />
    </v-layout>
  </v-container>
</template>

<script>
import InviteResponseForm from '@/components/InviteResponseForm.vue';

export default {
  name: 'RSVP',
  components: {
    InviteResponseForm,
  },
};

</script>

<style scoped></style>
